import { useEffect } from 'react'
import { useLocation } from 'react-router-dom-v5'

export const TheScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
